import React from 'react';
import { graphql } from 'react-relay';

import { BlogGbSCQueryResponse } from '@zego-types/BlogGbSCQuery.graphql';
import BaseLayout from '@zego/layouts/BaseLayout';
import withData from '@zego/lib/withData';
import Hero from '@zego/pageContainers/SeriesCRedesign/Blog/sections/Hero';
import News from '@zego/pageContainers/SeriesCRedesign/Blog/sections/News';
import { defaultSocialImage } from '@zego/socialImages';

import SCContentContainer from '@zego/components/SCContentContainer';

function BlogGbSC({ viewer }: BlogGbSCQueryResponse): JSX.Element {
  return (
    <BaseLayout
      viewer={viewer}
      headerIsInitiallyLightOnDark={false}
      unshiftHeader={true}
      title="Latest news"
      ogImage={defaultSocialImage({
        slogan: 'All the latest news from Zego',
        buttonLabel: 'Read more',
        category: 'News',
      })}
      ogImageWidth={2048}
      ogImageHeight={1170}
      headerContainer={SCContentContainer}
    >
      <Hero />
      <News viewer={viewer} />
    </BaseLayout>
  );
}

export default withData(BlogGbSC, {
  query: graphql`
    query BlogGbSCQuery($country: String!) {
      viewer {
        ...BaseLayout_viewer @arguments(country: $country)
        ...News_viewer @arguments(count: 6)
      }
    }
  `,
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
});
